import { ContainedIcon } from '@frontend/icons';
import { theme } from '@frontend/theme';

export const Warn = ({ as = 'span' }: { as?: React.ElementType }) => {
  return (
    <ContainedIcon
      as={as}
      css={{
        padding: 1,
        borderRadius: theme.borderRadius.small,
      }}
      iconName='aineeds-attention'
      background={theme.colors.gradients.warn}
      color={theme.colors.warning70}
    />
  );
};
